'use client';
import AgencyPortal from './components/AgencyPortal';

export default function AgencyPortalPage() {
  return <AgencyPortal />;
}
